import { DestinationDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class DestinationResponseModel extends GlobalResponseObject{
    data?: DestinationDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //DestinationDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DestinationDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
